export const pad = (s: number | string): string => String(s).padStart(2, "0");
